<template>
  <div>
    <!-- <carousels></carousels> -->
    <section class>
      <div class="container main-container">
        <div class="row">
          <div class="col-12 col-xl-6 text-left news-block">
            <!-- fb -->

            <div
              class="fb-page"
              data-href="https://www.facebook.com/369026003146037/"
              data-tabs="timeline"
              data-width="500"
              data-height="550"
              data-small-header="true"
              data-adapt-container-width="true"
              data-hide-cover="false"
              data-show-facepile="true"
            >
              <blockquote
                cite="https://www.facebook.com/369026003146037/"
                class="fb-xfbml-parse-ignore"
              >
                <a
                  href="https://www.facebook.com/369026003146037/"
                >久億光電科技有限公司/字幕機/招牌/顯示屏/看板/電視牆/設計規劃</a>
              </blockquote>
            </div>
            <!-- <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FJiuYiyuanZhangYiGuangDianKeJiYouXianGongSi%2F%3Fhc_ref%3DARTGsXYlphjAQ5A6-mO3uRsDb7FDt4ORNjZ1t4PojuneA34BM6XBtVqcTTWPY2i1KOI%26amp%3Bfref%3Dnf&tabs=timeline&width=500&height=210&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="210" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true"></iframe> -->
          </div>
          <div class="col-12 col-xl-6 text-left project-block">
            <div class="d-flex justify-content-between mb-1">
              <div class="col-auto bg-n-red">最新消息</div>
              <div class="col bg-n-gray">NEWS</div>
              <!-- <div class="col-auto">
                <router-link :to="{path:'news#1'}" class="text-dark" style="font-size:16px">More</router-link>
              </div>-->
            </div>
            <!-- <p class="mb-1">最新消息/News</p> -->
            <!-- <div class="underline"></div> -->
            <div class="list mb-0" style="margin-top:13px" v-if="needs.news">
              <div v-for="(item) in needs.news" :key="item.id" class>
                <router-link :to="{name:'newspage', params:{placeName:item.id}}" class="text-dark">
                  <div class="row font-xs-xl">
                    <div class="col-12 col-sm-8 col-md-12 col-lg-8 clamp-1">{{item['title']}}</div>
                    <div
                      class="col-4 d-none d-sm-block d-md-none d-lg-block text-right"
                    >{{item['created_date']}}</div>
                  </div>
                </router-link>
              </div>
            </div>
            <!-- <ul class="list mb-0" style="margin-top:13px">
              <li v-for="(item) in needs.news" :key="item.id" class="">
                <router-link :to="{name:'newspage', params:{placeName:item.id}}" class="text-dark">
                  <div class="row font-xs-xl" >
                    <div class="col-12 col-sm-8 col-md-12 col-lg-8 clamp-1">{{item['title']}}</div>
                    <div class="col-4 d-none d-sm-block d-md-none d-lg-block text-right">{{item['created_date']}}</div>
                  </div>

                </router-link>

              </li>
              
            </ul>-->
            <p class="text-right" style="margin-bottom:7.5px">
              <router-link
                :to="{path:'news#1'}"
                class="font-weight-bold"
                style="font-size:20px;color:rgb(175, 70, 20)"
              >more...</router-link>
            </p>

            <div class="d-flex" style="margin-bottom: 3.5px">
              <div class="col-auto bg-n-red">營業項目</div>
              <div class="col bg-n-gray">PROJECT</div>
              <!-- <div class="col-auto">
                <router-link :to="{path:'news#1'}" class="text-dark" style="font-size:16px">More</router-link>
              </div>-->
            </div>
            <!-- <p class="mb-1">營業項目/Project</p>

            <div class="underline"></div>-->
            <div class="row text-center">
              <div
                v-if="tags.length >= 1"
                v-show="index<=5"
                v-for="(item, index) in tags"
                :key="item.id"
                :data-checked="item.name"
                class="col-6 col-sm-4 col-xl-4 project-height shadow-text"
              >
                <router-link :to="{ name: 'charttest_tag', params: { page: '1', tag: item.id }}">
                  <img :src="item.image" alt class="img-force-100" />
                </router-link>
              </div>
              <!-- <div class="col-6 col-sm-4 col-md-6  col-lg-6 col-xl-4  project-height">
                <div class="d-flex  align-items-center h-100 bg-gray  ">
                  <div class="col">
                    <router-link :to="{ path:'/charttest?tag=3&page=1'}" class="text-white">電視牆</router-link>
                  </div>


                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-6  col-lg-6 col-xl-4  project-height">
                <div class="row  align-items-center h-100 bg-gray  mx-0">
                  <div class="col">
                    <router-link :to="{ path:'/charttest?tag=4&page=1'}" class="text-white">LED招牌</router-link>
                  </div>


                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-6  col-lg-6 col-xl-4  project-height">
                <div class="row  align-items-center h-100 bg-gray  mx-0">
                  <div class="col">
                    <router-link :to="{ path:'/charttest?tag=5&page=1'}" class="text-white">亮化工程</router-link>
                  </div>


                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-6  col-lg-6 col-xl-4  project-height">
                <div class="row  align-items-center h-100 bg-gray  mx-0">
                  <div class="col">
                    <router-link :to="{ path:'/charttest?tag=6&page=1'}" class="text-white">LED應用</router-link>
                  </div>


                </div>
              </div>

              <div class="col-6 col-sm-4 col-md-6  col-lg-6 col-xl-4  project-height">
                <div class="d-flex  align-items-center h-100 bg-gray  mx-0">
                  <div class="col">
                    <router-link :to="{ path:'/charttest?tag=39&page=1'}" class="text-white">舞台車</router-link>
                  </div>


                </div>
              </div>-->
            </div>
          </div>
        </div>

        <!-- container -->
      </div>

      <div class="result-div">
        <div class="container">
          <!-- 手機板 -->
          <div class="d-xl-none" style="margin-bottom:15px">
            <div class="row">
              <div class="col-auto bg-n-red" style="margin-left:15px">專業成果</div>
              <div class="col bg-n-gray text-left" style="margin-right:15px">RESULTS</div>
            </div>
          </div>
          <!-- 電腦版 -->
          <div class="d-none d-xl-block">
            <div class="row" style="margin-bottom:25px">
              <div class="col-auto text-red" style="font-size:38px">RESULTS</div>
              <!-- <div class="w-100"></div> -->
              <div
                class="col-auto bg-dark text-light"
                style="font-size:28px;margin-left:15px;width:145px"
              >
                <div class="row align-items-center h-100">
                  <div class="col">專業成果</div>
                </div>
              </div>

              <div class="col border-bottom border-dark pr-0" style="margin-right:15px">
                <div v-if="tags.length >= 1" class="row h-100 w-100 align-items-end" style="font-size:25px">
                  <div
                    class="col-auto ml-auto px-0"
                    @click="getEmit(tags[0]['id'])"
                    :class="{resultActive: sliderTag==tags[0]['id']}"
                    style="cursor:pointer"
                  >{{tags[0]['name']}}</div>
                  <div class="col-auto px-2">|</div>
                  <div
                    class="col-auto px-0"
                    @click="getEmit(tags[1]['id'])"
                    :class="{resultActive: sliderTag==tags[1]['id']}"
                    style="cursor:pointer"
                  >{{tags[1]['name']}}</div>
                  <div class="col-auto px-2">|</div>
                  <div
                    class="col-auto px-0"
                    @click="getEmit(tags[2]['id'])"
                    :class="{resultActive: sliderTag==tags[2]['id']}"
                    style="cursor:pointer"
                  >{{tags[2]['name']}}</div>
                  <div class="col-auto px-2">|</div>
                  <div
                    class="col-auto px-0"
                    @click="getEmit(tags[3]['id'])"
                    :class="{resultActive: sliderTag==tags[3]['id']}"
                    style="cursor:pointer"
                  >{{tags[3]['name']}}</div>
                  <div class="col-auto px-2">|</div>
                  <div
                    class="col-auto px-0"
                    @click="getEmit(tags[4]['id'])"
                    :class="{resultActive: sliderTag==tags[4]['id']}"
                    style="cursor:pointer"
                  >{{tags[4]['name']}}</div>
                                    <!--
                  <div class="col-auto px-2">|</div>

                  <div
                    class="col-auto px-0"
                    @click="getEmit(tags[5]['id'])"
                    :class="{resultActive: sliderTag==tags[5]['id']}"
                    style="cursor:pointer"
                  >{{tags[5]['name']}}</div>-->
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="underline" style="margin-bottom: 40px"></div> -->
          <!-- swiper -->
          <div class="row">
            <swiper :options="swiperOption" class="swiper1">
              <!-- slides -->
              <swiper-slide
                v-if="needs.messages"
                v-for="(item,index) in needs.messages"
                :key="item.id"
                @click.native="setImgText(index),showModal(item)"
                style="cursor:pointer"
              >
                <img :src="item['cover_image_s']" class="sliderimg" />
              </swiper-slide>

              <!-- Optional controls -->

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>

          <!-- swiper end -->
        </div>
      </div>

      <div class="white-block d-none d-xl-none"></div>
    </section>
    <!-- modal -->
    <b-modal
      ref="myModalRef"
      hide-header
      centered
      size="lg"
      title="Bootstrap-Vue"
      @shown="shownModal"
      @hidden="hiddenModal"
    >
      <div class="front-page" v-show="isFront">
        <div class="row m-0 w-100">
          <div class="col-12">
            <h3 class="text-center">{{needs.modalTitle}}</h3>
          </div>
          <!-- 圖片區 -->
          <div class="col-sm-7 py-3 order-sm-1 d-none d-sm-block">
            <iframe
              :src="needs.iframeurl"
              frameborder="0"
              style="width:100%;height: 300px"
              v-if="framepicked"
              allowfullscreen
            ></iframe>
            <img :src="needs.modalImg" alt style="width:100%" v-else />
          </div>
          <!-- 文字區 -->
          <div class="col-12 col-sm-5 order-2 order-sm-2 py-xl-3">
            <p class="wrap text-left px-3">{{needs.modalText}}</p>
          </div>
          <!-- 輪播區 -->
          <div class="col-12 my-3 mt-sm-3 order-1 order-sm-3">
            <swiper :options="swiperOption2" ref="mySwiper" class="px-0 px-sm-5">
              <swiper-slide
                @click.native="pickFrameToTop()"
                style="cursor:pointer"
                v-if="needs.iframeurl!=='' "
              >
                <iframe
                  :src="needs.iframeurl"
                  frameborder="0"
                  style="width:100%;height: 97.5px;z-index:-1;pointer-events: none"
                  class="d-none d-xl-block"
                ></iframe>
                <iframe
                  :src="needs.iframeurl"
                  frameborder="0"
                  style="width:100%;height: 268px;z-index:-1"
                  class="d-xl-none"
                  allowfullscreen
                ></iframe>
              </swiper-slide>
              <swiper-slide
                v-if="needs.modalImgList"
                v-for="(item,index) in needs.modalImgList"
                :key="item.id"
                @click.native="pickImgToTop(index)"
                style="cursor:pointer"
              >
                <img :src="item" alt />
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
      <!-- 反面 -->
      <div class="back-page" v-show="!isFront">
        <div class="container py-4">
          <!-- 公司圖 -->
          <div id="company-img" class="mb-3">
            <div class="d-inline-block">
              <img src="/static/chart/logo.png" alt />
            </div>
            <div class="d-inline-block font-weight-bold pl-3" style="font-size:24px">詢價單</div>
          </div>
          <!-- 主圖+名稱 -->
          <div id="picked-item" class="mb-3">
            <div class="font-weight-bold mb-2" style="font-size:30px">名稱: {{needs.modalTitle}}</div>
            <div class>
              <img :src="needs.modalImg" height="200px" width="200px" />
            </div>
          </div>
          <!-- 聯絡區塊 -->
          <div class="send-message text-left">
            <div class="row px-3">
              <div class="col-6 col-xl-2 mb-1 mb-xl-3">公司名稱</div>
              <b-form-input
                type="text"
                placeholder
                class="col-12 col-xl-4 mb-1 mb-xl-3"
                v-model="form.company"
              ></b-form-input>

              <div class="col-6 col-xl-2 mb-1 mb-xl-3">
                聯絡人
                <span style="color:rgb(171, 41, 43)">*</span>
              </div>
              <b-form-input
                type="text"
                placeholder
                class="col-12 col-xl-4 mb-1 mb-xl-3"
                v-model="form.user_name"
              ></b-form-input>
              <div class="col-6 col-xl-2 mb-1 mb-xl-3">
                EMAIL
                <span style="color:rgb(171, 41, 43)">*</span>
              </div>
              <b-form-input
                type="text"
                placeholder
                class="col-12 col-xl-4 mb-1 mb-xl-3"
                v-model="form.email"
              ></b-form-input>
              <div class="col-6 col-xl-2 mb-1 mb-xl-3">
                聯絡電話
                <span style="color:rgb(171, 41, 43)">*</span>
              </div>
              <b-form-input
                type="text"
                placeholder
                class="col-12 col-xl-4 mb-1 mb-xl-3"
                v-model="form.phone"
              ></b-form-input>
              <div class="col-6 col-xl-2 mb-1 mb-xl-3">傳真號碼</div>
              <b-form-input
                type="text"
                placeholder
                class="col-12 col-xl-4 mb-1 mb-xl-3"
                v-model="form.fax"
              ></b-form-input>
              <div class="col-6 col-xl-2 mb-1 mb-xl-3">聯絡地址</div>
              <b-form-input
                type="text"
                placeholder
                class="col-12 col-xl-4 mb-1 mb-xl-3"
                v-model="form.address"
              ></b-form-input>
            </div>

            <div class="row px-3">
              <div class="col-6 col-xl-2">
                備註
                <span style="color:rgb(171, 41, 43)">*</span>
              </div>
              <b-form-textarea
                class="col-12 col-xl-10"
                v-model="form.content"
                placeholder
                :rows="6"
                :max-rows="10"
              ></b-form-textarea>
            </div>
          </div>
        </div>
      </div>

      <div slot="modal-footer" class="w-100">
        <div class="row justify-content-center">
          <div class="col-auto px-1 px-sm-4" v-if="!isFront">
            <b-btn size="md" class="bg-danger" @click="sendMsg">送出</b-btn>
          </div>

          <div class="col-auto px-1 px-sm-4">
            <b-btn size="md" v-show="isFront" @click="isFront=!isFront">聯絡我們</b-btn>
            <b-btn size="md" v-show="!isFront" @click="isFront=!isFront">回上一頁</b-btn>
          </div>
          <div class="col-auto px-1 px-sm-4">
            <b-btn size="md" class="float-right bg-close" @click="hideModal">關閉</b-btn>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>



<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import NavBar2 from "./NavBar2";

//add

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
Vue.use(VueAxios, axios);
export default {
  data() {
    return {
      slider: [],
      sliderTag: 2,
      a: [
        // {xs:'/static/320/2.jpg',sm:'/static/576/1.jpg',md:'/static/576/1.jpg',lg:'/static/992/1.jpg',xl:'/static/1200/2.jpg'},
        {
          xs: "/static/320/2-2.jpg",
          sm: "/static/576/1-2.jpg",
          md: "/static/576/1-2.jpg",
          lg: "/static/992/1-2.jpg",
          xl: "/static/1200/2-2.jpg"
        },
        {
          xs: "/static/320/2-3.jpg",
          sm: "/static/576/1-3.jpg",
          md: "/static/576/1-3.jpg",
          lg: "/static/992/1-3.jpg",
          xl: "/static/1200/2-3.jpg"
        }
      ],
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 40,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          1200: {
            slidesPerView: 1
          },
          640: {
            slidesPerView: 1
          },
          320: {
            slidesPerView: 1
          }
        }
      },
      form: {
        user_name: "",
        email: "",
        phone: "",
        title: "",
        content: "",
        company: "",
        fax: "",
        address: "",
        id: ""
      },
      needs: {
        news: [],
        messages: [],
        modalImg: "",
        modalImgList: [],
        modalTitle: "",
        modalText: "",
        iframeurl: ""
      },
      isFront: true,
      swiperOption2: {
        lazy: false,
        autoHeight: false,
        slidesPerView: 5,
        spaceBetween: 30,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          576: {
            slidesPerView: 1,
            spaceBetween: 80
          }
        }
      },

      framepicked: false,
      tags: []
    };
  },
  methods: {
    pickFrameToTop() {
      this.framepicked = true;
    },
    sendMsg() {
      let vm = this;
      // console.log(vm.form);
      axios({
        method: "post",
        url: "https://iled.com.tw/bridging/api/v1/contact",
        params: vm.form
      }).then(function(response) {
        if (response.data.status == true) {
          alert(response.data.message);
          // add
          vm.hideModal();
        } else {
          alert(response.data.error[0]["message"]);
          //等等
        }
        // console.log(response);
      });
    },
    resetForm() {
      this.form.user_name = "";
      this.form.email = "";
      this.form.phone = "";
      this.form.title = "";
      this.form.content = "";
      this.form.company = "";
      this.form.fax = "";
      this.form.address = "";
      this.form.id = "";
    },
    updateSwiper() {
      let vm = this;
      vm.$refs.mySwiper.update();
    },
    pickImgToTop(index) {
      this.needs.modalImg = this.needs.modalImgList[index];
      this.framepicked = false;
    },
    setImgText(index) {
      // console.log(this.needs.messages);
      this.needs.modalImgList = [];

      this.needs.messages[index]["images_1x1"].forEach(element => {
        this.needs.modalImgList.push(
          "https://iled.com.tw/bridging" + element
        );
      });
      this.needs.modalImg = this.needs.modalImgList[0];
      this.needs.modalTitle = "";
      this.needs.modalTitle = this.needs.messages[index]["title"];
      this.needs.modalText = "";
      this.needs.modalText = this.needs.messages[index]["description"];
      this.needs.iframeurl = "";
      this.needs.iframeurl = this.needs.messages[index]["youtube_link"];

      this.needs.modalId = "";
      this.needs.modalId = this.needs.messages[index]["id"];
      // console.log("id");
      // console.log(this.needs.modalId);
      this.form.id = this.needs.modalId;
      // console.log(this.form.id);
    },
    showModal() {
      let vm = this;
      vm.$refs.myModalRef.show();
      if (vm.needs.iframeurl !== "") vm.framepicked = true;
      else vm.framepicked = false;
    },
    shownModal() {
      let vm = this;
      vm.$refs.mySwiper.update();
    },

    hideModal() {
      this.$refs.myModalRef.hide();
    },
    hiddenModal() {
      this.isFront = true;
      this.framepicked = true;
      this.resetForm();
      this.swiper.slideTo(0, 1000, false);
    },
    DS() {},
    getEmit: function(xxx) {
      // console.log(xxx);
      this.sliderTag = xxx;
      this.getSliderData();
    },
    pusha() {
      let vm = this;
      vm.$emit("pusha", vm.a);
    },
    getSliderData() {
      let vm = this;
      axios({
        method: "post",
        url: "https://iled.com.tw/bridging/api/v1/products",
        params: {
          limit: 6,
          slider: 1,
          cover_image: 1,
          categories: this.sliderTag
        }
      }).then(function(response) {
        vm.needs.messages = [];
        if (response.data.data.length > 0) {
          response.data.data.forEach(element => {
            element["cover_image_s"] =
              "https://iled.com.tw/bridging" + element["cover_image_s"];
            vm.needs.messages.push(element);
          });
        }
        // console.log(vm.needs.messages);
      });
    },
    getData() {
      let vm = this;

      axios({
        method: "post",
        url: "https://iled.com.tw/bridging/api/v1/news/list",
        params: {
          limit: 3,

          offset: 0
        }
      }).then(function(response) {
        vm.needs.news = [];
        response.data.data.forEach(element => {
          vm.needs.news.push(element);
        });
      });
    },
    getAllTag: function() {
      let vm = this;
      axios({
        method: "post",
        url: "https://iled.com.tw/bridging/api/v1/categories"
      }).then(function(response) {
        // console.log("this");
        // console.log(response);
        response.data.data.forEach(element => {
          element.image = "https://iled.com.tw/bridging" + element.image;
          vm.tags.push(element);
        });
      });
    }
  },

  components: {
    NavBar2,
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },

  created: function() {
    this.pusha();
    this.getData();
    this.getAllTag();

    if (window.innerWidth < 1200) {
      this.sliderTag = 0;
    }

    this.getSliderData();
  },
  mounted() {
    var windowsize = document.documentElement.clientWidth;
    this.window_width = windowsize;
    FB.XFBML.parse();
  },
  beforeUpdate() {
    var windowsize = document.documentElement.clientWidth;
    this.window_width = windowsize;
    FB.XFBML.parse();
  }
};
</script>
<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"

.main-container
  @include media-breakpoint-up(xs)
    padding-top: 55px
    padding-bottom: 60px
  @include media-breakpoint-up(xl) 
    padding-top: 96px
    padding-bottom: 96px

.nav-2
  margin-top: 95px
  &.active
    color: red


.underline
  height: 5px
  // border-top: 5px solid black
  background-color: black
  position: relative
  &:after
    content: ''
    position: absolute
    width: 55px
    height: 5px
    background-color: rgb(185, 40 , 45)
    // border-bottom: 5px solid rgb(185, 40 , 45)
    z-index: 10
    left: 0%
    top: 0
    bottom: 0
    // transform: translateY(-50%)
.bg-gray
  background-color: rgb(205, 205, 205)
  color: rgb(125, 125, 125)
  font-size: 18px
.project-height 
  @include media-breakpoint-up(xs) 
    min-height: 156px
    
.clamp-1
  overflow: hidden
  text-overflow: ellipsis
  display: -webkit-box
  -webkit-line-clamp: 1
  /*! autoprefixer: off */
  -webkit-box-orient: vertical
  /* autoprefixer: on */
.sliderimg 
  max-height: 100%
.wrap
  white-space: pre-wrap  
.item-title
  font-weight: bold
  font-size: 23px
  color: black
.sliderimg 
  max-height: 100%

.bg-close
  background-color: rgb(200, 85, 30)
  &:hover
    background-color: rgb(175, 70, 20)
.swiper-button-prev
  background-image: url('/static/icon/icon-07@4x.png')
  background-size: contain
  width: 50px
  left: -2px
.swiper-button-next
  background-image: url('/static/icon/icon-08@4x.png')
  background-size: contain
  width: 50px
  right: -2px

.text-red
  color: rgb(185, 40 , 45)
.resultActive
  color: rgb(185, 40 , 45)

.white-block
  height: 218px

.bg-n-red
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(182, 40 ,44)
  color: white
  text-align: center
  padding-top: 7px
  padding-bottom: 7px
.bg-n-gray
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(51, 58, 64)
  color: white
  padding-left: 13px
  padding-top: 7px
  padding-bottom: 7px
.news-block
  @include media-breakpoint-up(xs)
    margin-bottom: 50px 
  @include media-breakpoint-up(xl) 
    padding-left: 0
    padding-right: 70px
.project-block
  @include media-breakpoint-up(xl) 
    padding-left: 70px
    padding-right: 0
  .project-height
    padding: 0 7.5px
    margin-bottom: 7.5px
    margin-top: 7.5px
  .row
    margin-left: -7.5px
    margin-right: -7.5px
.swiper1
  @include media-breakpoint-up(xl) 
    padding: 0 40px

.result-div
  @include media-breakpoint-up(xl)  
    background-color: rgb(238,238,239)
    padding: 100px 0
  @include media-breakpoint-up(xs)
    margin-bottom: 0 
.font-xs-xl
  @include media-breakpoint-up(xl)  
    font-size: 18px
  @include media-breakpoint-up(xs)
    font-weight: bold
.img-force-100
  width: 100% !important
.shadow-text
  position: relative
  &::after
    content: attr(data-checked)
    color: rgb(255, 255 , 255)
    font-weight: bold
    @include media-breakpoint-up(xs)  
      padding-top: 0px
    @include media-breakpoint-up(md)  
      padding-top: 8px
    @include media-breakpoint-up(xl)  
      padding-top: 0px
    pointer-events: none
    position: absolute
    left: 7.5px
    right: 7.5px
    bottom: 0
    height: 20%
    background-color: rgba(0, 0, 0, .8)
.shadow-text
  &:hover:after
    color: rgb(185, 40 , 45)
    background-color: rgba(255, 255, 255, .9)

</style>




// WEBPACK FOOTER //
// src/components/MainPage.vue